/* eslint-disable no-inline-styles/no-inline-styles */
import React, { FC } from "react";
import { IButtonProps, Link } from "@fluentui/react";
import { Label, useTheme } from "cayo.ui";
import { Entity } from "@cayo/shared/api/types/cayo-graph";
import { IFormField } from "@cayo/shared/api/types/schema";
import { Row } from "@cayo/shared/components/CommonLayout";
import clipboardUtils from "@cayo/shared/utils/clipboard";
import { ObjectLinkContainer } from "./styles";
import Icon from "../../Graphics/Icon";

const ResolvedObjectLink: FC<
  IFormField & {
    navObject: Entity;
    objectName: string;
    objIcon?: string;
    onClick?: () => void;
    commands?: IButtonProps[];
  }
> = (props) => {
  const { officeTheme } = useTheme();

  const { navObject, objectName, objIcon, onClick, commands, disabled } = props;

  return (
    <ObjectLinkContainer>
      <Label
        label={props.label}
        tooltip={props.tooltip}
        onCopy={
          navObject.objectName
            ? () => clipboardUtils.copyToClipboard(navObject.objectName ?? "")
            : undefined
        }
        commands={commands}
      />

      <Row valign={true}>
        {objIcon && <Icon iconName={objIcon} style={{ marginRight: 4 }} />}

        <Link
          onClick={onClick}
          disabled={disabled}
          styles={{
            root: {
              display: "block",
              alignItems: "center",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            },
          }}
        >
          {objectName}
        </Link>
        <Icon
          iconName={"NavigateExternalInline"}
          style={{
            paddingLeft: 2,
            fontSize: 13,
            color: disabled
              ? officeTheme.semanticColors.disabledText
              : officeTheme.semanticColors.link,
          }}
        />
      </Row>
    </ObjectLinkContainer>
  );
};

export default ResolvedObjectLink;
